// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1a_0_","vLegacy":"SelectSecondary_vLegacy__35KC5","error":"SelectSecondary_error__2PiPu","disabled":"SelectSecondary_disabled__akNi2"};